import {
	requests
}from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/ReLocalityType/create', params),
	update        : (params) => requests.post('/ReLocalityType/update', params),
	delete        : (params) => requests.getWithParams('/ReLocalityType/delete', params),
	restore       : (params) => requests.getWithParams('/ReLocalityType/restore', params),
	getPaged      : (params) => requests.getWithParams('/ReLocalityType/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/ReLocalityType/getPagedAudit', params),
	getPagedAll   : (params) => requests.getWithParams('/ReLocalityType/getPagedAll', params),
	getList       : (params) => requests.getWithParams('/ReLocalityType/getList', params)
}